import { participantInstance } from "./api";
const url = process.env.REACT_APP_BASE_URL || "/";

async function getIctInventoryList(page,limit,filter, inventory_code) {

    const api =
      url +
      `/participants/ict/inventories/list?inventory_code=${inventory_code}&page=${page}&filter=${filter}&limit=${limit}`;
  
    return await participantInstance
      .get(api)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error.response;
      });
  }

  async function getIctEvaluationList(page, limit, filter) {
    const api =
      url +
      `/participants/ict/evaluations/list?page=${page}&filter=${filter}&limit=${limit}`;
    return await participantInstance
      .get(api)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error.response;
      });
  }

  async function getIctFollowupList(page, limit, filter) {
    const api =
      url +
      `/participants/ict/followups/list?page=${page}&filter=${filter}&limit=${limit}`;
    return await participantInstance
      .get(api)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error.response;
      });
  }
  export const participantIctListService = {
    getIctInventoryList,
    getIctEvaluationList,
    getIctFollowupList
  }